export default __webpack_public_path__ + "static/media/history_museum_london.d34ef334.jpg";